import React from 'react';
import { Link } from 'react-router-dom'

const Subscription = () => {

    const list = [
        {
          id: '1001',
          name: 'Himanshu Rawat',
          contact: '9131251818',
          numberOfPerson: '2',
          paidAmount: '$ 450',
          tableNo: '18',
          source: 'Website',
          bookingDate: '25 June 2021',
          bookingTime : '5:00 PM',
          createdOn: '22 May 2021',
          rating : '4.1',
          comment : 'Very Tasty food !',
          status: 'Active',
        }
      ]


    return (
        <div className="w-full p-6 ">

            <div className="flex items-center justify-between w-full ">

                <p className="min-w-max font-semibold text-gray-700">Platform Subscription </p>

                <div className="flex items-center ">
                    <button className="p-2 px-4 m-3 bg-red-400 text-white text-sm">Record Payment</button>
                    <button className="p-2 px-4 m-3  border rounded-sm border-4 border-red-300 text-red-400 text-sm">Generate Invoice</button>

                    <div className="flex items-center px-4 bg-white rounded-md  border border-white hover:border-red-300">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.1665 3.33329C5.94484 3.33329 3.33317 5.94496 3.33317 9.16663C3.33317 12.3883 5.94484 15 9.1665 15C12.3882 15 14.9998 12.3883 14.9998 9.16663C14.9998 5.94496 12.3882 3.33329 9.1665 3.33329ZM1.6665 9.16663C1.6665 5.02449 5.02437 1.66663 9.1665 1.66663C13.3086 1.66663 16.6665 5.02449 16.6665 9.16663C16.6665 13.3088 13.3086 16.6666 9.1665 16.6666C5.02437 16.6666 1.6665 13.3088 1.6665 9.16663Z" fill="#39424E" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2856 13.2857C13.611 12.9603 14.1387 12.9603 14.4641 13.2857L18.0891 16.9107C18.4145 17.2361 18.4145 17.7638 18.0891 18.0892C17.7637 18.4147 17.236 18.4147 16.9106 18.0892L13.2856 14.4642C12.9601 14.1388 12.9601 13.6111 13.2856 13.2857Z" fill="#39424E" />
                        </svg>
                        <input className="px-4 p-3 text-center text-gray-700 text-md focus:outline-none  " placeholder="search query here" />
                    </div>
                    {/* search box ends here  */}
                </div>

            </div>

            <div className="mt-3 flex flex-col">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 align-middle inline-block min-w-full sm:px-3 lg:px-8">
                        <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            ID
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Type
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            $ Value
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Start Date
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            End Date
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Payment Methods
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Remark
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Created By
                                        </th>



                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Created On
                                        </th>


                                        <th
                                            scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Receipt
                                        </th>
                                    </tr>
                                </thead>

                                <tbody className="bg-white divide-y divide-gray-200">

                                    {list && list.map((item, index) => {

                                        return (
                                            <tr key={index}>
                                                <td className="px-3 py-4 whitespace-nowrap text-sm text-blue-400">
                                                    Id : {item.id}
                                                </td>

                                                <Link to={`/restaurants/${item.id}`}><td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
                                                    {item.name}
                                                </td></Link>

                                                <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {item.contact}
                                                </td>

                                                <td className="px-3 py-4 whitespace-nowrap text-sm font-bold text-red-500 ">
                                                    {item.numberOfPerson}
                                                </td>

                                                <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {item.paidAmount}
                                                </td>

                                                <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {item.tableNo}
                                                </td>


                                                <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {item.source}
                                                </td>

                                                <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {item.bookingDate}
                                                </td>



                                                <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {item.createdOn}
                                                </td>




                                                <td>
                                                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                                        Download
                                                    </span>
                                                </td>
                                            </tr>
                                        )
                                    })}




                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Subscription;
